// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w1RN","colBig":"styles_colBig__2LStE","colSmall":"styles_colSmall__2IWqb"};